import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../service/global.service';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {

  constructor(private GlobalService: GlobalService) {
    GlobalService.CheckPagingAccessRights();
  }

  ngOnInit(): void {
  }

}
